import UiRenderer from './UiRenderer';

export default UiRenderer;
